// extracted by mini-css-extract-plugin
export default {"rewardsContainer":"Protocol_rewardsContainer__OELmr","header":"Protocol_header__iVxTI"};